import { axios } from '@/utils/request'
const api = {
  source: '/order/transport',
  remark: '/order/remark',
  accessory: '/order/accessory',
  relation: '/order/relation',
  order: '/order/order',
  price: '/order/price',
  enterpriseDemand: '/enterprise/demand'
}
// 获取萤石ids
export function getEzvizEnterpriseIdListApi (parameter) {
  return axios({
    url: '/order/order/getEzvizEnterpriseIdList',
    method: 'get',
    params: parameter
  })
}
// 签到成功
export function signInOrderApi (parameter) {
  return axios({
    url: '/order/wechat/process/masterSign',
    method: 'post',
    data: parameter
  })
}
// 提交签字图片
export function addDetectionResultApi (parameter) {
  return axios({
    url: '/order/acceptance/addDetectionResult',
    method: 'post',
    data: parameter
  })
}

// 订单详情 查询企业品牌，渠道，信息来源
export function selectEnterpriseinfo (parameter) {
  return axios({
    url: '/enterprise/source/selectEnterpriseinfo',
    method: 'get',
    params: parameter
  })
}

// // 新增包裹信息 // 更新包裹信息
export function getaddTransport (parameter) {
  return axios({
    url: api.source + (parameter.transportId ? '/updateTransport' : '/addTransport'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// //新增备注信息 // 更新订单备注
export function getaddOrderRemark (parameter) {
  return axios({
    url: api.remark + '/addOrderRemark',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 批量改价
export function getchangePriceBatch (parameter) {
  return axios({
    url: '/order/price/changePriceBatch',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 追加订单备注
export function getaddAppendInfo (parameter) {
  return axios({
    url: api.remark + '/addAppendInfo',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// //查询当前订单可以新增的金额类型
export function getcanAddPriceTypes (parameter) {
  return axios({
    url: '/order/price/canAddPriceTypes',
    method: 'get',
    params: parameter
  })
}
export function getprocessor (parameter) {
  return axios({
    url: '/backlog/pendingMatter/processor',
    method: 'get',
    params: parameter
  })
}
export function getaddAudit (parameter) {
  return axios({
    url: '/backlog/audit/addAudit',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// //新增备注信息 // 更新订单备注
export function getupdateOrderRemark (parameter) {
  return axios({
    url: api.remark + '/updateOrderRemark',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getsetNoSettle (parameter) {
  return axios({
    url: '/order/orderStatus/setNoSettle',
    method: 'post',
    // params: parameter,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getquickProcess (parameter) {
  return axios({
    url: '/backlog/pendingMatter/quickProcess',
    method: 'post',
    // params: parameter,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getorderRemoveSubstatus (parameter) {
  return axios({
    url: '/order/orderStatus/orderRemoveSubstatus',
    method: 'post',
    // params: parameter,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getorderFrozenManual (parameter) {
  return axios({
    url: '/order/orderStatus/orderFrozenManual',
    method: 'post',
    // params: parameter,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getfeedbacklist (parameter) {
  return axios({
    url: '/backlog/app/feedback/list',
    method: 'get',
    params: parameter
  })
}
export function getselectOrderFrozen (parameter) {
  return axios({
    url: '/order/orderStatus/selectOrderFrozen',
    method: 'get',
    params: parameter
  })
}
export function getselectOrderManualFrozen (parameter) {
  return axios({
    url: '/order/orderStatus/selectOrderManualFrozen',
    method: 'get',
    params: parameter
  })
}
export function getselectNoSettle (parameter) {
  return axios({
    url: '/order/orderStatus/selectNoSettle',
    method: 'get',
    params: parameter
  })
}
export function getcomplaintslist (parameter) {
  return axios({
    url: '/backlog/app/complaints/list',
    method: 'get',
    params: parameter
  })
}
export function getmyPendingMatters (parameter) {
  return axios({
    url: '/backlog/union/myPendingMatters',
    method: 'get',
    params: parameter
  })
}

// 获取企业要求列表
export function getenterpriseDemandList (parameter) {
  return axios({
    url: api.enterpriseDemand + '/list',
    method: 'get',
    params: parameter
  })
}
export function getPendingMattersSubtype (parameter) {
  return axios({
    url: '/backlog/pendingMatter/getPendingMattersSubtype',
    method: 'get',
    params: parameter
  })
}
// 2.3 获取订单表头
export function getOrderHeader (parameter) {
  return axios({
    url: '/order/sort/getOrderHeader',
    method: 'get',
    params: parameter
  })
}
// 2.2 查询用户订单排序
export function getUserOrderSort (parameter) {
  return axios({
    url: '/order/sort/getUserOrderSort',
    method: 'get',
    params: parameter
  })
}
// 首次预约失败
export function getreserveFailed (parameter) {
  return axios({
    url: 'order/order/reserveFailed',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 新增订单排序
export function getaddUserOrderSort (parameter) {
  return axios({
    url: '/order/sort/addUserOrderSort',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 师傅改约
export function getchangeReservation (parameter) {
  return axios({
    url: '/order/app/process/changeReservation',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getorderImportant (parameter) {
  return axios({
    url: '/order/orderStatus/orderImportant',
    method: 'post',
    params: parameter
  })
}
export function getorderUrgent (parameter) {
  return axios({
    url: '/order/orderStatus/orderUrgent',
    method: 'post',
    params: parameter
  })
}
export function getorderUrgentByMoney (parameter) {
  return axios({
    url: '/order/orderStatus/orderUrgentByMoney',
    method: 'post',
    params: parameter
    // params: parameter,
  })
}
export function getsaleOrderData (parameter) {
  return axios({
    url: '/order/order/saleOrderData',
    method: 'get',
    params: parameter
  })
}
//
export function getsaleDataSave (parameter) {
  return axios({
    url: '/order/orderInstall/saleDataSave',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getdisablesale (parameter) {
  return axios({
    url: '/order/cost/disable',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getdeletesale (parameter) {
  return axios({
    url: '/order/cost/delete',
    method: 'post',
    params: parameter
  })
}
// // 新增订单配件 // 更新订单配件
export function addOrderAccessory (parameter) {
  return axios({
    url: api.accessory + (parameter.orderAccessoryId ? '/updateOrderAccessory' : '/addOrderAccessory'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 删除包裹信息
export function getdelTransport (parameter) {
  return axios({
    url: api.source + '/delTransport',
    method: 'get',
    params: parameter
  })
}
// 获取物流信息
export function getTransportInfo (parameter) {
  return axios({
    url: api.source + '/getTransportInfo',
    method: 'get',
    params: parameter
  })
}
// 删除备注信息
export function getdeleteOrderRemark (parameter) {
  return axios({
    url: api.remark + '/deleteOrderRemark',
    method: 'get',
    params: parameter
  })
}

// 退回配件
export function getreturnOrderAccessory (parameter) {
  return axios({
    url: api.accessory + '/returnOrderAccessory',
    method: 'get',
    params: parameter
  })
}
// 作废配件
export function getinvalidOrderAccessory (parameter) {
  return axios({
    url: api.accessory + '/invalidOrderAccessory',
    method: 'get',
    params: parameter
  })
}

// 查询关联订单信息
export function getsearchOrderRelation (parameter) {
  return axios({
    url: api.relation + '/searchOrderRelation',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 更新订单信息
export function getupdateOrder (parameter) {
  return axios({
    url: api.order + '/updateOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 验证订单
export function getverificationOrder (parameter) {
  return axios({
    url: api.order + '/verificationOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 价格新增
export function getaddPrice (parameter) {
  return axios({
    url: '/order/price/addPrice',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单关系互换
export function getexchangeOrderRelation (parameter) {
  return axios({
    url: api.relation + '/exchangeOrderRelation',
    method: 'get',
    params: parameter
  })
}
// 1.1.1客服审核

export function getcustomerServiceApply (parameter) {
  return axios({
    url: '/order/orderProcess/customerServiceApply',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
/// 待修改 通过 不通过
export function getenterpriseUpdate (parameter) {
  return axios({
    url: 'order/orderProcess/enterpriseUpdate',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.1.9订单退单
export function getreturnOrder (parameter) {
  return axios({
    url: 'order/orderProcess/returnOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 客服退单
export function getdispatchOrder (parameter) {
  return axios({
    url: 'order/orderProcess/dispatchOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.1.3师傅接单
export function getreceiveOrder (parameter) {
  return axios({
    url: 'order/orderProcess/receiveOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 批量接单
export function getreceiveOrders (parameter) {
  return axios({
    url: 'order/orderProcess/receiveOrders',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.1.10关闭订单
export function getcloseOrder (parameter) {
  return axios({
    url: 'order/orderProcess/closeOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.1.5师傅预约
export function getreservationOrder (parameter) {
  return axios({
    url: 'order/orderProcess/reservationOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getreservationOrders (parameter) {
  return axios({
    url: 'order/orderProcess/reservationOrders',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.1.7订单核销
export function getreviewOrder (parameter) {
  return axios({
    url: 'order/orderProcess/reviewOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.1.6师傅安装
export function getinstallOrder (parameter) {
  return axios({
    url: 'order/orderProcess/installOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.1.8订单完成
export function getcompleteOrder (parameter) {
  return axios({
    url: 'order/orderProcess/completeOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.1.8订单完成
export function getassignOrder (parameter) {
  return axios({
    url: 'order/orderProcess/assignOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 金额类型getcompleteOrder
export function getbasicPricelist (parameter) {
  return axios({
    url: 'basicdata/basicPrice/list',
    method: 'get',
    params: parameter
  })
}
export function getByPriceType (parameter) {
  return axios({
    url: 'enterprise/price/getByPriceType',
    method: 'get',
    params: parameter
  })
}
// 改价
export function getchangePrice (parameter) {
  return axios({
    url: 'order/price/changePrice',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 审核
export function getaudit (parameter) {
  return axios({
    url: 'order/price/audit',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getaddFeedback (parameter) {
  return axios({
    url: 'backlog/feedback/addFeedback',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 1.2.4新增投诉

export function getaddComplaint (parameter) {
  return axios({
    url: 'backlog/complaints/addComplaint',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function queryPriceByIdAndType (parameter) {
  return axios({
    url: 'master/masterPrice/queryPriceByIdAndType',
    method: 'get',
    params: parameter
  })
}

// 改价列表
export function getchangePriceList (parameter) {
  return axios({
    url: api.price + '/changePriceList',
    method: 'get',
    params: parameter
  })
}
// 1.2.2获取登陆人投诉权限
export function getComplaintAuthority (parameter) {
  return axios({
    url: 'backlog/complaints/getComplaintAuthority',
    method: 'get',
    params: parameter
  })
}
// 1.3.2获取登录人问题反馈权限
export function getFeedbackAuthority (parameter) {
  return axios({
    url: 'backlog/feedback/getFeedbackAuthority',
    method: 'get',
    params: parameter
  })
}
// 取消订单关系
export function getcancelOrderRelation (parameter) {
  return axios({
    url: api.relation + '/cancelOrderRelation',
    method: 'get',
    params: parameter
  })
}

// 获取萤石原始单号
export function determineIsEzvizSn (parameter) {
  return axios({
    url: '/aqara/ezvizOrder/determineIsEzvizSn',
    method: 'get',
    params: parameter
  })
}
// 获取萤石SN
export function getYsSn (parameter) {
  return axios({
    url: '/order/orderInstall/getSn',
    method: 'get',
    params: parameter
  })
}
// 校验萤石序列号
export function checkEzvizSn (parameter) {
  return axios({
    url: '/aqara/ezvizOrder/checkEzvizSn',
    method: 'post',
    data: parameter
  })
}
// 萤石序列号提交
export function verifyYsSn (parameter) {
  return axios({
    url: '/order/orderInstall/verifySn',
    method: 'post',
    data: parameter
  })
}
// 判断萤石订是安装单还是维修单
export function judgeOrderType (parameter) {
  return axios({
    url: '/order/orderInstall/judgeOrderType',
    method: 'post',
    data: parameter
  })
}

// 查询萤石订单是否需要管控
export function determineIsForceControl (parameter) {
  return axios({
    url: '/aqara/ezvizOrder/determineIsForceControl',
    method: 'post',
    data: parameter
  })
}

// 获取萤石锁体配件列表
export function getPartsListInfo (parameter) {
  return axios({
    url: '/aqara/ezvizOrder/getPartsListInfo',
    method: 'post',
    data: parameter
  })
}

// 获取萤石工单详情
export function getEzvizOrderDetail (parameter) {
  return axios({
    url: '/aqara/ezvizOrder/detailInfo',
    method: 'post',
    data: parameter
  })
}

// 获取维修工单可选配件列表
export function getRepairOptions (parameter) {
  return axios({
    url: '/aqara/ezvizOrder/getRepairOptions',
    method: 'post',
    data: parameter
  })
}

// 验证维修报告（修改&新增）
export function verifyRepairOptions (parameter) {
  return axios({
    url: '/order/orderInstall/verifyRepairOptions',
    method: 'post',
    data: parameter
  })
}

// 查询维修报告
export function getRepairReport (parameter) {
  return axios({
    url: '/order/orderInstall/getRepairReport',
    method: 'post',
    data: parameter
  })
}

export const sourceExport = api.source + '/export'
